import React, { useState } from 'react'
import stylesIndex from '../../../css/Index.module.css'
import styles from '../../../css/preferences/AgentAdministration.module.css'
import Header from '../../../components/generals/header'
import Windows from '../../../img/windows.jpeg'
import Android from '../../../img/android.jpeg'
import { Card } from 'primereact/card'
import Button from 'react-bootstrap/Button'
import { useSelector } from 'react-redux'
import { config } from '../../../config'
import { popupSimple } from '../../../components/generals/popups'
import { useTranslation } from 'react-i18next'

export default function AgentAdministration () {
  const user = useSelector((state) => state.user)
  const role = user.roles
  const { t } = useTranslation('agentPreferences')

  const [optionWindows, setOptionWindows] = useState('')
  const [optionAndroid, setOptionAndroid] = useState('')

  const headerWindows = (
        <div className={styles.div_header}>
            <p className={styles.bold}>{t('label1')}</p>
            <img alt={'card para windows'} src={Windows} className={styles.img_header} />
        </div>
  )
  const headerAndroid = (
        <div className={styles.div_header}>
            <p className={styles.bold}>{t('label2')}</p>
            <img alt={'card para android'} src={Android} className={styles.img_header}/>
        </div>
  )

  const agents = [
    {
      agent: 'Windows',
      img: Windows,
      version: '4.0.3.5',
      noteVersion: [t('noteVersion1'), t('noteVersion2')],
      optionsSelect: ['Windows 10', 'Windows 11'],
      header: headerWindows,
      visible: role?.preferencesAgentPage.downloadWindowsAgent
    },
    {
      agent: 'Android',
      img: Android,
      version: '4.0.3.5',
      noteVersion: [t('noteVersion3'), t('noteVersion4')],
      optionsSelect: ['Android 12', 'Android 13', 'Android 14', 'Android 15'],
      header: headerAndroid,
      visible: role?.preferencesAgentPage.downloadAndroidAgent
    }
  ]

  const downloadAgent = async (option) => {
    if (option === '') {
      popupSimple('info', t('message1'))
    } else {
      popupSimple('info', t('message2'))

      let route
      if (option.includes('Android')) {
        route = `${config.backend.host}:${config.backend.portHttp}/download/MDM/agent_android/zip`
      } else if (option.includes('Windows')) {
        route = `${config.backend.host}:${config.backend.portHttp}/download/MDM/agent_windows/exe`
      }

      const link = document.createElement('a')
      link.href = route
      link.rel = 'noopener noreferrer'
      document.body.appendChild(link)
      link.click()
    }
  }

  return (
            <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
                <div className={`content  ${stylesIndex.mainContent}`}>
                    <Header title={t('title')} margin="0" />
                    <p>{t('paragraph1')}</p>
                    <p>{t('paragraph2')} <span className={styles.bold}>{t('paragraph3')}</span> {t('paragraph4')} <span className={styles.bold}>{t('paragraph5')}</span></p>
                    {agents.map((agent) => {
                      if (agent?.visible) {
                        return (
                          <Card key={agent?.agent} className={styles.card} header={agent?.header}>
                                    <p className={styles.bold}>{t('label3')}<span className={styles.light}>{` ${agent?.version}`}</span></p>
                                    <p className={styles.bold}>{t('label4')}</p>
                                  {console.log(agent)}
                                    <ul className={styles.ul_noteVersion}>
                                        {agent?.noteVersion.map((note, index) => {
                                          return (
                                            <li key={index}><i className={`fas fa-check ${styles.margin_right}`}></i>{note}</li>
                                          )
                                        })}
                                    </ul>
                                    <select
                                        id={`options_agent_${agent?.agent}`}
                                        className={styles.select}
                                        onChange={agent?.agent === 'Windows' ? (e) => setOptionWindows(e.target.value) : (e) => setOptionAndroid(e.target.value)}
                                        name={`options_agent_${agent?.agent}`}
                                        defaultValue={'seleccionar'}
                                    >
                                        <option key={'default'} disabled="disabled" value={'seleccionar'}>{t('option')}</option>
                                        {agent?.optionsSelect.map((option) => {
                                          return (
                                                <option key={option} value={option}>{option}</option>
                                          )
                                        })}
                                    </select>
                                    <div className={styles.container_btn}>
                                        <Button variant="dark" className={styles.buttonSave} onClick={() => downloadAgent(agent.agent === 'Windows' ? optionWindows : optionAndroid)} id="btnDownloadAgent">
                                            <i className={`fas fa-download ${styles.margin_right}`}></i>
                                            {t('button')}
                                        </Button>
                                    </div>
                                </Card>
                        )
                      }
                      return (<></>)
                    })}
                </div>
            </div>
  )
}
